import { isObservable, observable, reaction } from 'mobx';
import { makeObservable, toJS } from 'mobx';
import { IParameter, ParameterObject, TParameterType } from './types';
import { getLabel } from '@apia/util';

export class Parameter<T extends IParameter = IParameter>
  implements ParameterObject
{
  public state: T & { validationError?: string };

  public component?: string;

  constructor(
    params: T & {
      component?: string;
    },
  ) {
    this.component = params.component;
    this.state = params;
    this.state.type = this.state.type.toLowerCase() as TParameterType;
    this.state.values = this.state.values || [];
    this.removeEmptyValues();

    if (!isObservable(this.state)) {
      makeObservable<Parameter<T>, 'state'>(this, {
        state: observable,
      });
    }

    reaction(
      () => this.state.values,
      () => delete this.state.validationError,
    );
  }

  clear() {
    this.state.values.splice(0, this.state.values.length);
  }

  getValues() {
    return this.state.values;
  }

  private removeEmptyValues() {
    this.state.values = this.state.values.filter((x) => !!x);
  }

  setValue(value: string, index?: number) {
    //this.removeEmptyValues();
    index !== null && index !== undefined
      ? (this.state.values[index] = value)
      : (this.state.values = [value]);
  }

  addValue(value: string) {
    this.removeEmptyValues();
    this.state.values[this.state.values.length] = value;
  }

  setValues(values: string[], index = 0) {
    this.removeEmptyValues();
    values.forEach((x, i) => (this.state.values[index + i] = x));
    for (let i = values.length; i < this.state.values.length; i++) {
      delete this.state.values[i];
    }
  }

  removeValue(value: string) {
    this.state.values = this.getValues().filter((x) => !!x && x !== value);
  }

  asPayloadElement() {
    return this.state.type === 'label'
      ? null
      : toJS(this.state.values.filter((x) => !!x));
  }

  includes(value: string) {
    return this.state.values.includes(value);
  }

  validate() {
    const isValid = !this.state.required || !!this.state.values[0];
    this.state.validationError = isValid
      ? undefined
      : getLabel('msgReqField').text;
    return isValid;
  }

  setComponent(component?: string) {
    this.component = component;
  }
}
